export default "__VITE_ASSET__1df4036d__"